import './modal-overlay.styles.scss';

import ModalOverlayService from './modal-overlay.service';

export default angular.module('directives.abModalOverlay', [ModalOverlayService])
  .directive('abModalOverlay', () => {
    'ngInject';

    return {
      restrict: 'E',
      transclude: true,
      templateUrl: require('./modal-overlay.template.html'),
    };
  })
  .directive('dynamic', ($compile) => {
    'ngInject';

    return {
      restrict: 'A',
      replace: true,
      link(scope, ele, attrs) {
        scope.$watch(attrs.dynamic, (html) => {
          ele.html(html);
          $compile(ele.contents())(scope);
        });
      },
    };
  })
  .name;
